// extracted by mini-css-extract-plugin
export var animateCircle = "section-component-module--animate-circle--8sArv";
export var bounce = "section-component-module--bounce--hsgdQ";
export var content = "section-component-module--content--nUN6A";
export var ldsRing = "section-component-module--lds-ring--Jq97O";
export var light = "section-component-module--light--EvVt4";
export var section = "section-component-module--section--xzKae";
export var title = "section-component-module--title--5aO0Z";